import { Injectable } from '@angular/core';
import { CommandHandlerResolver } from '../../../core/service/command/command-handler-resolver.service';
import { CreateContractCommandHandler } from './create-contract-command-handler.service';
import { vacantRentalObjectCommand } from '../../model/const/command';
import { CreateBlockContractRentalObjectCommandHandler } from './create-blockcontract-rental-object-command-handler.service';
import { VacantOtherExportCommandHandler } from './vacant-other-export-command-handler.service';

@Injectable()
export class VacantOtherCommandHandlerResolver extends CommandHandlerResolver {
  constructor(
    createContractHandler: CreateContractCommandHandler,
    createBlockContractHandler: CreateBlockContractRentalObjectCommandHandler,
    exportToExcelHandler: VacantOtherExportCommandHandler
  ) {
    super();
    this.addHandler(vacantRentalObjectCommand.createContract, createContractHandler);
    this.addHandler(vacantRentalObjectCommand.createBlockContract, createBlockContractHandler);
    this.addHandler(vacantRentalObjectCommand.exportToExcel, exportToExcelHandler);
  }
}
